import ServiceLearningProjectIcon from './component.jsx'
export default ServiceLearningProjectIcon
